export default __webpack_public_path__ + "static/energy_conservation-380142242e96c7e676c8eceeadc68421.jpg";